/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { FormLayout, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getFullAppUrlV2 } from 'src/helpers';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ToolBarSortByForm extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n } = this.props;

    const sortByOptionUrl = getFullAppUrlV2('/custom-sorting');

    return (
      <FormLayout>
        <div className="form-section">
          <div className="form-section__item">
            <p className="description-section">
              {i18n.translate('AdminHTML.ThemeSetting.Form.toolBar_ProductCount_SortBy_HelpText', {
                t1: (
                  <Link url={sortByOptionUrl} external>
                    {i18n.translate(
                      'AdminHTML.ThemeSetting.Form.toolBar_ProductCount_SortBy_HelpText_t1'
                    )}
                  </Link>
                )
              })}
            </p>
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ToolBarSortByForm);
